"use server";

import { createClient } from "@/lib/supabase/server";
import { redirect } from "next/navigation";
import { cookies } from "next/headers";

const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? "https://atendia.dev.bmore.app";

export async function login(formData: FormData) {
  const supabase = await createClient();

  const email = formData.get("email") as string;
  const password = formData.get("password") as string;

  const { data, error } = await supabase.auth.signInWithPassword({ email, password });

  if (error) {
    redirect("/login?error=invalid_credentials");
  }

  // Sync preferred_locale from profile to cookie
  if (data.user) {
    const { data: profile } = await supabase
      .from("profiles")
      .select("preferred_locale")
      .eq("user_id", data.user.id)
      .single();

    if (profile?.preferred_locale) {
      const cookieStore = await cookies();
      cookieStore.set("NEXT_LOCALE", profile.preferred_locale, {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
        httpOnly: false,
        sameSite: "lax",
      });
    }
  }

  redirect("/");
}

export async function logout() {
  const supabase = await createClient();
  await supabase.auth.signOut();
  redirect(`${APP_URL}/login`);
}
